/* global ga */
/* global mixpanel */

import settings from "config/settings";

const gaSend = (...args) => {
  if (settings.GA_TRACKING_ID && ga) {
    return ga("send", ...args);
  }
};

const gaSet = (...args) => {
  if (settings.GA_TRACKING_ID && ga) {
    return ga("set", ...args);
  }
};

const mixpanelPeopleDeleteUser = () => {
  if (settings.MIXPANEL_TOKEN && mixpanel) {
    return mixpanel.people.delete_user();
  }
};

const mixpanelPeopleSet = (properties) => {
  if (settings.MIXPANEL_TOKEN && mixpanel) {
    return mixpanel.people.set(properties);
  }
};

const mixpanelTrack = (eventName, properties) => {
  if (settings.MIXPANEL_TOKEN && mixpanel) {
    return mixpanel.track(eventName, properties);
  }
};

export const setUser = (userId, userData={}) => {
  gaSet("userId", userId);
  if (userId) {
    mixpanelPeopleSet({
      ...userData,
      id: userId,
    });
  } else {
    mixpanelPeopleDeleteUser();
  }
};

export const trackEvent = (label, gaEventData, mpEventData) => {
  const [gaCategory, gaAction, gaValue] = gaEventData;
  gaSend("event", gaCategory, gaAction, label, gaValue);
  mixpanelTrack(label, mpEventData);
};

export const trackPage = (pathname=null) => {
  gaSend("pageview", pathname);
};

export default {
  setUser,
  trackEvent,
  trackPage,
};



/** WEBPACK FOOTER **
 ** ./src/app/metrics.js
 **/